<!-- Toolbar -->
<div class="op-toolbar">
  <div class="op-search">
    <emerald-icon class="op-search-ic">search</emerald-icon>
    <input
      type="text"
      [value]="filterValue"
      (keyup)="searchItem($event)"
      placeholder="Search name, position, email, location, manager, status…"
      aria-label="Search candidates"
    />
    <button
      *ngIf="filterValue?.length && filterValue.length > 0"
      class="op-search-clear"
      (click)="clearInput()"
      aria-label="Clear search"
    >✕</button>
  </div>

  <div class="op-chips" *ngIf="activeFilterCount">
    <span class="op-chip" *ngIf="activeFilters.status">Status: <b>{{ activeFilters.status }}</b></span>
    <span class="op-chip" *ngIf="activeFilters.jobTitle">Position: <b>{{ activeFilters.jobTitle }}</b></span>
    <span class="op-chip" *ngIf="activeFilters.location">Location: <b>{{ activeFilters.location }}</b></span>
  </div>

  <div class="op-spacer"></div>

  <div class="op-filter-slot">
    <button class="op-filterbtn" (click)="toggleFilterPanel()">
      <emerald-icon>filter_list</emerald-icon> Filters
      <span class="op-filter-count" *ngIf="activeFilterCount">{{ activeFilterCount }}</span>
    </button>
    <div class="op-filter-backdrop" *ngIf="showFilterPanel" (click)="showFilterPanel = false"></div>
    <div class="op-filter-panel" *ngIf="showFilterPanel">
      <div class="op-fp-head">Filter candidates</div>
      <div class="op-fp-row">
        <label class="op-fp-label">Status</label>
        <select class="op-fp-field" [(ngModel)]="filterDraft.status">
          <option value="">All</option>
          <option *ngFor="let v of facetStatus" [value]="v">{{ v }}</option>
        </select>
      </div>
      <div class="op-fp-row">
        <label class="op-fp-label">Position</label>
        <select class="op-fp-field" [(ngModel)]="filterDraft.jobTitle">
          <option value="">All</option>
          <option *ngFor="let v of facetJobTitle" [value]="v">{{ v }}</option>
        </select>
      </div>
      <div class="op-fp-row">
        <label class="op-fp-label">Location</label>
        <select class="op-fp-field" [(ngModel)]="filterDraft.location">
          <option value="">All</option>
          <option *ngFor="let v of facetLocation" [value]="v">{{ v }}</option>
        </select>
      </div>
      <div class="op-fp-actions">
        <button class="op-fp-reset" (click)="resetFilterPanel()">Reset</button>
        <button class="op-fp-apply" (click)="applyFilterPanel()">Apply</button>
      </div>
    </div>
  </div>
</div>

<!-- Table -->
<div class="op-table-wrap" *ngIf="displayCandidatesData?.length; else noData">
  <table class="op-table">
    <colgroup>
      <col style="width:14%" /><col style="width:11%" /><col style="width:5%" />
      <col style="width:9%" /><col style="width:8%" /><col style="width:8%" />
      <col style="width:10%" /><col style="width:5%" /><col style="width:9%" />
      <col style="width:21%" />
    </colgroup>
    <thead>
      <tr>
        <th class="sortable" (click)="sortBy('candidateName')" (mouseenter)="showTip($event, 'Name')" (mouseleave)="hideTip()">Name <span class="op-sort" [ngClass]="sortIndicator('candidateName')"></span></th>
        <th class="sortable" (click)="sortBy('jobTitle')" (mouseenter)="showTip($event, 'Position')" (mouseleave)="hideTip()">Position <span class="op-sort" [ngClass]="sortIndicator('jobTitle')"></span></th>
        <th class="sortable" (click)="sortBy('yearsOfExperience')" (mouseenter)="showTip($event, 'Experience')" (mouseleave)="hideTip()">Exp <span class="op-sort" [ngClass]="sortIndicator('yearsOfExperience')"></span></th>
        <th class="sortable" (click)="sortBy('location')" (mouseenter)="showTip($event, 'Location')" (mouseleave)="hideTip()">Location <span class="op-sort" [ngClass]="sortIndicator('location')"></span></th>
        <th class="sortable" (click)="sortBy('createdDate')" (mouseenter)="showTip($event, 'Date applied')" (mouseleave)="hideTip()">Applied <span class="op-sort" [ngClass]="sortIndicator('createdDate')"></span></th>
        <th class="sortable" (click)="sortBy('earliestAvailability')" (mouseenter)="showTip($event, 'Available by')" (mouseleave)="hideTip()">Available <span class="op-sort" [ngClass]="sortIndicator('earliestAvailability')"></span></th>
        <th (mouseenter)="showTip($event, 'Hiring Manager')" (mouseleave)="hideTip()">Hiring Manager</th>
        <th (mouseenter)="showTip($event, 'Aging')" (mouseleave)="hideTip()">Aging</th>
        <th class="sortable" (click)="sortBy('status')" (mouseenter)="showTip($event, 'Status')" (mouseleave)="hideTip()">Status <span class="op-sort" [ngClass]="sortIndicator('status')"></span></th>
        <th>Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of displayCandidatesData; trackBy: trackByIndex">
        <td (mouseenter)="showTip($event, row.candidateName)" (mouseleave)="hideTip()">
          <div class="cd-name">
            <span class="op-tip-txt cd-name-main">{{ row.candidateName }}</span>
            <span class="cd-name-sub muted">{{ row.emailId }}</span>
          </div>
        </td>
        <td (mouseenter)="showTip($event, row.jobTitle)" (mouseleave)="hideTip()"><span class="op-tip-txt">{{ row.jobTitle }}</span></td>
        <td class="mono">{{ row.yearsOfExperience }}</td>
        <td (mouseenter)="showTip($event, candidateLocation(row))" (mouseleave)="hideTip()"><span class="op-tip-txt">{{ candidateLocation(row) }}</span></td>
        <td class="mono muted">{{ row.createdDate | date: dateFormat.Month }}</td>
        <td class="mono muted">{{ row.earliestAvailability | date: dateFormat.Month }}</td>
        <td (mouseenter)="showTip($event, row.hiringManagerName)" (mouseleave)="hideTip()"><span class="op-tip-txt">{{ row.hiringManagerName }}</span></td>
        <td><span class="op-age" [ngClass]="agingClass(row.agingDays)">{{ row.agingDays }}d</span></td>
        <td>
          <span class="op-pill" [ngClass]="statusClass(row.status)"><span class="dot"></span>{{ row.status }}</span>
        </td>
        <td class="op-cell-actions">
          <div class="op-actions">
            <button
              *ngIf="row.resumePath"
              class="op-iconbtn"
              title="Download resume"
              (click)="downloadFile(row.resumePath, row.candidateName, 'resume')"
            ><emerald-icon>download</emerald-icon></button>
            <button
              *ngIf="row.additionalDocumentsPath"
              class="op-iconbtn"
              title="Download screening feedback"
              (click)="downloadFile(row.additionalDocumentsPath, row.candidateName, 'attachments')"
            ><emerald-icon>description</emerald-icon></button>
            <app-candidate-feedback
              *ngIf="fieldsVisibility && row.emailId"
              (sendFeedbackStatus)="receiveData($event, row.emailId)"
              [candidateId]="row.candidateId"
              [fieldsVisibility]="fieldsVisibility"
            ></app-candidate-feedback>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<ng-template #noData>
  <section class="op-empty" aria-label="Records section">
    <ng-container *ngIf="isDataLoaded; else loadingState">
      <h2 class="op-empty-title">No Records Found</h2>
      <img [src]="imageSrc" alt="No records illustration" class="op-empty-img" />
    </ng-container>
    <ng-template #loadingState>
      <h2 class="op-empty-title op-loading-title">Loading candidates…</h2>
    </ng-template>
  </section>
</ng-template>

<!-- Pagination footer -->
<div class="op-tfoot" *ngIf="displayCandidatesData?.length">
  <div class="op-info">Showing <b>{{ rangeStart }}–{{ rangeEnd }}</b> of <b>{{ totalRecords }}</b> candidates</div>
  <div class="op-pager">
    <button class="pg" (click)="prevPage()" [disabled]="currentPageValue === 1" aria-label="Previous page">‹</button>
    <button
      *ngFor="let p of pageWindow; trackBy: trackByIndex"
      class="pg"
      [class.on]="p === currentPageValue"
      [disabled]="p === -1"
      (click)="goToPage(p)"
    >{{ p === -1 ? '…' : p }}</button>
    <button class="pg" (click)="nextPage()" [disabled]="currentPageValue >= totalPages" aria-label="Next page">›</button>
  </div>
  <div class="op-psize">
    <span>Rows</span>
    <select [value]="pageSizeValue" (change)="onPageSizeChange($event)" aria-label="Rows per page">
      <option [value]="5">5</option>
      <option [value]="10">10</option>
      <option [value]="20">20</option>
    </select>
  </div>
</div>

<!-- Fixed hover tooltip -->
<div class="op-hovertip" *ngIf="hoverTip.show" [style.left.px]="hoverTip.x" [style.top.px]="hoverTip.y">
  {{ hoverTip.text }}
</div>
